<template>
  <span
    :title="title"
    :class="[
      'inline-flex items-center px-1.5 py-0.5 rounded text-[11px] font-medium transition-colors duration-150',
      colorClasses,
      filled ? 'text-white' : ''
    ]"
  >
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'PracticeTag',
  props: {
    category: {
      type: String,
      default: 'type',
      validator: (val) => ['aco', 'volume', 'type', 'population', 'setting', 'tech'].includes(val),
    },
    variant: {
      type: String,
      default: null,
      validator: (val) => val === null || ['success', 'warning', 'error'].includes(val),
    },
    filled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    colorClasses() {
      // If variant is specified, use semantic colors
      if (this.variant === 'success') {
        return 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100'
      }
      if (this.variant === 'warning') {
        return 'bg-amber-50 text-amber-700 hover:bg-amber-100'
      }
      if (this.variant === 'error') {
        return 'bg-red-50 text-red-700 hover:bg-red-100'
      }

      // Filled variant (for ACO status)
      if (this.filled) {
        const filledColors = {
          aco: 'bg-slate-600 hover:bg-slate-700',
          volume: 'bg-amber-600 hover:bg-amber-700',
          type: 'bg-blue-600 hover:bg-blue-700',
          population: 'bg-purple-600 hover:bg-purple-700',
          setting: 'bg-teal-600 hover:bg-teal-700',
          tech: 'bg-gray-600 hover:bg-gray-700',
        }
        return filledColors[this.category] || filledColors.type
      }

      // Category-based muted colors using CSS variables
      const categoryColors = {
        aco: 'bg-slate-100 text-slate-700 hover:bg-slate-200',
        volume: 'bg-amber-50 text-amber-800 hover:bg-amber-100',
        type: 'bg-blue-50 text-blue-700 hover:bg-blue-100',
        population: 'bg-purple-50 text-purple-700 hover:bg-purple-100',
        setting: 'bg-cyan-50 text-cyan-700 hover:bg-cyan-100',
        tech: 'bg-gray-100 text-gray-600 hover:bg-gray-200',
      }
      return categoryColors[this.category] || categoryColors.type
    },
  },
}
</script>
